<form [formGroup]="form" novalidate>
  <br />
  <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
  <div class="sketch-container" #sketchContainer1>
    <div fxLayout="row" *ngIf="!hasPath">
      <wm-sketch-field
        formControlName="sketchField1"
        (EndEvent)="finishedSketching($event)"
      >
      </wm-sketch-field>
    </div>
    <div fxLayout="row" *ngIf="hasPath && imagePath">
      <img
        [src]="imagePath"
        alt="Sketch Image"
        style="max-width: 100%; height: auto;"
      />
    </div>
    <div fxLayout="row">
      <button
        type="button"
        class="btn btn-raised btn-sm btn-danger"
        (click)="clear()"
        [disabled]="false"
      >
        Clear
      </button>
    </div>
  </div>
</form>
